import { Spin } from "antd";
import { Card, CardBody, Col } from "reactstrap";
import { useState } from "react";
import Chart from "react-apexcharts";
import { getQuizResultsChartConfig } from "../ChartsData/ApexChart";
import QuizResultsCardHeader from "./QuizResultsCardHeader";
import QuizResultsCardFooter from "./QuizResultsCardFooter";

const QuizResults = ({ allStudents, allCourses, loading }) => {
  const [selectedCourseId, setSelectedCourseId] = useState("All Courses");

  const activeCourses = allCourses?.filter(course => course.isCurrent);
  const activeCourseIds = new Set(activeCourses?.map(course => course.id));

  const courseIdNameMap = {};
  activeCourses.forEach(course => {
    courseIdNameMap[course.id] = `${course.name} (${course.type})`;
  });

  const activeCourseStudents = allStudents?.filter(student => {
    const courseId = student?.courses?.[student.courseIndex]?.courseId;
    return activeCourseIds.has(courseId);
  });

  const categoryStats = {};

  activeCourseStudents?.forEach(student => {
    const courseId = student?.courses?.[student.courseIndex]?.courseId;

    if (selectedCourseId !== "All Courses" && courseId !== selectedCourseId) return;

    student?.result?.forEach(res => {
      const category = res?.category;
      if (!categoryStats[category]) {
        categoryStats[category] = { totalScore: 0, count: 0 };
      }
      categoryStats[category].totalScore += res.marks;
      categoryStats[category].count += 1;
    });
  });

  const categories = Object.keys(categoryStats);
  const data = categories.map(cat => {
    const { totalScore, count } = categoryStats[cat];
    return count ? +(totalScore / count).toFixed(2) : 0;
  });

  const courseStats = {};

  activeCourseStudents?.forEach(student => {
    const courseId = student?.courses?.[student.courseIndex]?.courseId;
    const course = allCourses.find(c => c.id === courseId);
    if (!course) return;

    if (!courseStats[courseId]) {
      courseStats[courseId] = { totalScore: 0, count: 0, courseName: course.name, courseType: course.type };
    }

    student?.result?.forEach(res => {
      courseStats[courseId].totalScore += res.marks;
      courseStats[courseId].count += 1;
    });
  });

  const quizScoresStats = Object.entries(courseStats).map(([id, stat]) => {
    const { count, totalScore, courseName, courseType } = stat;
    const avg = count ? (totalScore / count).toFixed(2) : 0;
    return {
      courseName: courseName,
      courseType: courseType,
      percentage: avg
    };
  });

  const allTotalScore = Object.values(courseStats).reduce((acc, cur) => acc + cur.totalScore, 0);
  const allQuizCount = Object.values(courseStats).reduce((acc, cur) => acc + cur.count, 0);

  const overallAverage = allQuizCount ? +(allTotalScore / allQuizCount).toFixed(2) : 0;

  const chartData = getQuizResultsChartConfig(data, categories, categoryStats);

  return (
    <Col md="6" xl="6" className="box-col-33">
      <Card className="our-earning relative">
      {loading && <div className={`charts-initial-loading`}><Spin /></div>}
        <QuizResultsCardHeader overallAverage={overallAverage} selectedCourseId={selectedCourseId} setSelectedCourseId={setSelectedCourseId} />
        <CardBody className="p-0">
          <Chart options={chartData.options} series={chartData.series} type="bar" height={300} />
        </CardBody>
        <QuizResultsCardFooter quizScoresStats={quizScoresStats} />
      </Card>
    </Col>
  );
};

export default QuizResults;